import React from 'react';

import DocumentList from 'buyside/components/presentation/DocumentList/documentList';

import { employerProfileDocumentUrl } from 'buyside/util/urlHelper';

const MarketingMaterials = ({ fundProfile: { marketingMaterials } }) => {
  return <DocumentList documents={marketingMaterials} urlFn={employerProfileDocumentUrl} />;
};

export default MarketingMaterials;
